/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IUser } from 'app/shared/model/user.model';
import { IContactDetails } from 'app/shared/model/contact-details.model';
import { IHospital } from 'app/shared/model/hospital.model';

export interface INurse {
  id?: string;
  education?: string | null;
  training?: string | null;
  experience?: string | null;
  achievements?: string | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  name?: string;
  email?: string;
  age?: number | null;
  gender?: string | null;
  mobile?: string | null;
  dateOfBirth?: number | null;
  bloodGroup?: string | null;
  tmUser?: IUser;
  contactCode?: IContactDetails;
  hospital?: IHospital;
}

export const defaultValue: Readonly<INurse> = {
  active: false,
};
